/* @generated */

// ../src/breadcrumb/breadcrumb.tsx
import classNames5 from "classnames";
import * as React13 from "react";

// ../src/breadcrumb/link/index.tsx
import * as React8 from "react";

// ../src/breadcrumb/constants.ts
var OVERFLOW_ICON_WIDTH = {
  small: 24,
  standard: 32,
  medium: 32,
  large: 32
};
var DIVIDER_WIDTH = {
  small: 18.875,
  standard: 20.016,
  medium: 20.016,
  large: 20.016
};
var MAX_INLINE_ITEMS = 4;
var LINK_HIDDEN_ID_PREFIX = "digBreadcrumbLink--hidden";

// ../src/breadcrumb/link/hidden_link.tsx
import * as React6 from "react";

// ../src/breadcrumb/context.tsx
import * as React from "react";
var defaultValue = {
  size: "medium",
  updateSegment: () => void 0,
  hasTrailingDivider: false,
  overflowTriggerProps: {}
};
var BreadcrumbContext = React.createContext(defaultValue);

// ../src/breadcrumb/link/link_context.tsx
import * as React2 from "react";
var defaultValue2 = 0;
var LinkContext = React2.createContext(defaultValue2);

// ../src/breadcrumb/utils.tsx
import * as React3 from "react";
import flattenChildren from "react-keyed-flatten-children";
var isAllUpdated = (segments) => {
  return segments.every((segment) => !segment.linkProps.children || segment.width !== 0);
};
var calcItemWidth = (ref) => {
  if (ref.current) {
    return ref.current.getBoundingClientRect().width;
  }
  return 0;
};
var calcBreadcrumbWidth = (inlineSegments, overflowSegments, size, hasTrailingDivider = false) => {
  let width = 0;
  if (!isAllUpdated(inlineSegments)) {
    return 0;
  }
  inlineSegments.forEach((segment) => {
    width += segment.width;
  });
  if (width === 0) {
    return 0;
  }
  width += (inlineSegments.length - 1) * DIVIDER_WIDTH[size];
  if (overflowSegments.length > 0) {
    width += OVERFLOW_ICON_WIDTH[size] + DIVIDER_WIDTH[size];
  }
  if (hasTrailingDivider) {
    width += DIVIDER_WIDTH[size];
  }
  return width;
};
var initSegments = (children) => {
  const segments = [];
  flattenChildren(children).forEach((child) => {
    if (React3.isValidElement(child)) {
      segments.push({
        item: child,
        width: 0,
        linkProps: {}
      });
    }
  });
  return segments;
};
var buildBreadcrumb = ({
  availableWidth,
  breadcrumbSegments,
  size,
  isRootOverflow,
  alwaysShowRoot,
  hasTrailingDivider
}) => {
  let inlineSegments = breadcrumbSegments;
  let overflowSegments = [];
  let breadcrumbWidth = calcBreadcrumbWidth(
    inlineSegments,
    overflowSegments,
    size,
    hasTrailingDivider
  );
  if (breadcrumbWidth === 0) {
    return {
      inline: inlineSegments,
      overflow: []
    };
  }
  if (inlineSegments.length > MAX_INLINE_ITEMS) {
    const index = isRootOverflow ? 0 : 1;
    const segments = [
      ...inlineSegments.slice(index, inlineSegments.length - MAX_INLINE_ITEMS + index)
    ];
    inlineSegments = [
      ...inlineSegments.slice(0, index),
      ...inlineSegments.slice(inlineSegments.length - MAX_INLINE_ITEMS + index)
    ];
    overflowSegments = overflowSegments.concat(segments);
    breadcrumbWidth = calcBreadcrumbWidth(
      inlineSegments,
      overflowSegments,
      size,
      hasTrailingDivider
    );
  }
  while (true) {
    if (availableWidth > breadcrumbWidth) {
      if (inlineSegments.length === MAX_INLINE_ITEMS || overflowSegments.length === 0) {
        break;
      }
      let segmentIndex = overflowSegments.length - 1;
      if (inlineSegments.length === 1 && !isRootOverflow) {
        segmentIndex = 0;
      }
      const segment = overflowSegments[segmentIndex];
      if (overflowSegments.length === 1) {
        if (segment.width > availableWidth - (breadcrumbWidth - OVERFLOW_ICON_WIDTH[size])) {
          break;
        }
      } else {
        if (segment.width + DIVIDER_WIDTH[size] > availableWidth - breadcrumbWidth) {
          break;
        }
      }
      inlineSegments = inlineSegments.length === 1 || isRootOverflow ? [segment, ...inlineSegments] : [...inlineSegments.slice(0, 1), segment, ...inlineSegments.slice(1)];
      overflowSegments = [
        ...overflowSegments.slice(0, segmentIndex),
        ...overflowSegments.slice(segmentIndex + 1)
      ];
      breadcrumbWidth = calcBreadcrumbWidth(
        inlineSegments,
        overflowSegments,
        size,
        hasTrailingDivider
      );
    } else {
      const minPathLen = !isRootOverflow && alwaysShowRoot ? 2 : 1;
      if (inlineSegments.length <= minPathLen) {
        break;
      }
      let segmentIndex = 1;
      if (inlineSegments.length === 2 || isRootOverflow) {
        segmentIndex = 0;
      }
      const segment = inlineSegments[segmentIndex];
      inlineSegments = [
        ...inlineSegments.slice(0, segmentIndex),
        ...inlineSegments.slice(segmentIndex + 1)
      ];
      overflowSegments = segmentIndex !== 0 || isRootOverflow ? overflowSegments.concat(segment) : [segment].concat(overflowSegments);
      breadcrumbWidth = calcBreadcrumbWidth(
        inlineSegments,
        overflowSegments,
        size,
        hasTrailingDivider
      );
    }
  }
  return {
    inline: inlineSegments,
    overflow: overflowSegments
  };
};
var buildBreadcrumbWithLinksDisplayed = ({
  breadcrumbSegments,
  isRootOverflow,
  linksDisplayed
}) => {
  let inlineSegments = [];
  let overflowSegments = [];
  if (linksDisplayed <= 0) {
    return {
      inline: inlineSegments,
      overflow: overflowSegments
    };
  }
  if (breadcrumbSegments.length <= linksDisplayed) {
    inlineSegments = [...breadcrumbSegments];
  } else {
    overflowSegments = [...breadcrumbSegments];
    while (inlineSegments.length < linksDisplayed) {
      if (isRootOverflow) {
        const segment = overflowSegments[overflowSegments.length - 1];
        inlineSegments = [segment, ...inlineSegments];
        overflowSegments = [...overflowSegments.slice(0, overflowSegments.length - 1)];
      } else {
        if (inlineSegments.length === 0) {
          const segment = overflowSegments[overflowSegments.length - 1];
          inlineSegments = [segment, ...inlineSegments];
          overflowSegments = [...overflowSegments.slice(0, overflowSegments.length - 1)];
        } else if (inlineSegments.length === 1) {
          const segment = overflowSegments[0];
          inlineSegments = [segment, ...inlineSegments];
          overflowSegments = [...overflowSegments.slice(1)];
        } else {
          const segment = overflowSegments[overflowSegments.length - 1];
          inlineSegments = [...inlineSegments.slice(0, 1), segment, ...inlineSegments.slice(1)];
          overflowSegments = [...overflowSegments.slice(0, overflowSegments.length - 1)];
        }
      }
    }
  }
  return {
    inline: inlineSegments,
    overflow: overflowSegments
  };
};

// ../src/breadcrumb/link/link_content.tsx
import classNames from "classnames";
import * as React5 from "react";
import { UIIcon } from "@dropbox/dig-icons";
import { Title, Text } from "@dropbox/dig-components/typography";

// ../src/_global/sizes.tsx
var deprecationMap = [
  // [<modern-value>, <legacy-value>]
  ["medium", "standard"]
];
var getMigratedComponentSize = (size) => {
  const mapping = deprecationMap.find(([_newVal, deprecatedVal]) => size === deprecatedVal);
  if (mapping !== void 0) {
    return mapping[0];
  }
  return size;
};

// ../src/breadcrumb/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var breadcrumb = _7a468({ defaultClassName: "dig-nmoxl3_21-7-0", variantClassNames: { size: { small: "dig-nmoxl4_21-7-0", medium: "dig-nmoxl5_21-7-0", large: "dig-nmoxl6_21-7-0" }, typography: { text: "dig-nmoxl7_21-7-0", title: "dig-nmoxl8_21-7-0" }, isLinksDisplayed: { true: "dig-nmoxl9_21-7-0" } }, defaultVariants: { size: "medium" }, compoundVariants: [[{ size: "small", typography: "text" }, "dig-nmoxla_21-7-0"], [{ size: "medium", typography: "text" }, "dig-nmoxlb_21-7-0"], [{ size: "large", typography: "text" }, "dig-nmoxlc_21-7-0"], [{ size: "small", typography: "title" }, "dig-nmoxld_21-7-0"], [{ size: "medium", typography: "title" }, "dig-nmoxle_21-7-0"], [{ size: "large", typography: "title" }, "dig-nmoxlf_21-7-0"]] });
var breadcrumbDivider = "dig-nmoxll_21-7-0";
var breadcrumbDividerTrailing = "dig-nmoxlm_21-7-0";
var breadcrumbInner = "dig-nmoxlg_21-7-0";
var breadcrumbLink = _7a468({ defaultClassName: "dig-nmoxln_21-7-0", variantClassNames: { isCurrent: { true: "dig-nmoxlo_21-7-0" }, isDraggedOver: { true: "dig-nmoxlp_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var breadcrumbLinkContent = "dig-nmoxlq_21-7-0";
var breadcrumbLinkIcon = "dig-nmoxls_21-7-0";
var breadcrumbLinkInner = "dig-nmoxlr_21-7-0";
var breadcrumbLinkText = "dig-nmoxlt_21-7-0";
var breadcrumbOverflowButton = "dig-nmoxli_21-7-0";
var breadcrumbOverflowMenuItem = _7a468({ defaultClassName: "dig-nmoxlj_21-7-0", variantClassNames: { isDraggedOver: { true: "dig-nmoxlk_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var breadcrumbWidthCalcUtil = "dig-nmoxlh_21-7-0";

// ../src/breadcrumb/link/utils.ts
import React4 from "react";
var pickNavigationProps = ({
  isCurrentPath,
  href,
  onClick
}) => {
  const navigationProps = { onClick };
  if (!isCurrentPath) {
    switch (typeof href) {
      case "string":
        navigationProps.href = href;
        break;
      case "function":
        navigationProps.href = "#";
        navigationProps.onClick = (evt) => {
          evt.preventDefault();
          href(evt);
          if (onClick) {
            onClick(evt);
          }
        };
        break;
    }
  }
  return navigationProps;
};
var useLinkDrag = ({
  onDragOver: _onDragOver,
  onDragEnter: _onDragEnter,
  onDragLeave: _onDragLeave,
  onDrop: _onDrop
}) => {
  const [isDraggedOver, setIsDraggedOver] = React4.useState(false);
  const onDragOver = React4.useCallback(
    (e) => {
      setIsDraggedOver(true);
      if (_onDragOver) {
        _onDragOver(e);
      }
    },
    [_onDragOver]
  );
  const onDragEnter = React4.useCallback(
    (e) => {
      setIsDraggedOver(true);
      if (_onDragEnter) {
        _onDragEnter(e);
      }
    },
    [_onDragEnter]
  );
  const onDragLeave = React4.useCallback(
    (e) => {
      setIsDraggedOver(false);
      if (_onDragLeave) {
        _onDragLeave(e);
      }
    },
    [_onDragLeave]
  );
  const onDrop = React4.useCallback(
    (e) => {
      setIsDraggedOver(false);
      if (_onDrop) {
        _onDrop(e);
      }
    },
    [_onDrop]
  );
  return {
    isDraggedOver,
    onDragOver,
    onDragEnter,
    onDragLeave,
    onDrop
  };
};
var uiIconToTypographySizeMap = {
  text: {
    small: "small",
    medium: "medium",
    large: "medium"
  },
  title: {
    small: "medium",
    medium: "large",
    large: "large"
  }
};
var iconSizerfier = ({
  typography: _typography,
  size: _size
}) => {
  const size = getMigratedComponentSize(_size);
  let typography = _typography;
  if (!typography) {
    typography = size === "small" ? "text" : "title";
  }
  const resolvedSize = uiIconToTypographySizeMap[typography][size];
  return resolvedSize;
};

// ../src/breadcrumb/link/link_content.tsx
var LinkContent = React5.forwardRef(
  ({
    id,
    className,
    children,
    withLeftIcon,
    // Unused, but don't pass it in rest
    withMenuItemIcon: _,
    isCurrentPath = false,
    href,
    onClick,
    _originalId = "",
    onDrop,
    onDragEnter,
    onDragOver,
    onDragLeave,
    linkContentRef,
    ...rest
  }, ref) => {
    const { size: _size, typography } = React5.useContext(BreadcrumbContext);
    const size = getMigratedComponentSize(_size);
    const WrapperTag = isCurrentPath ? "span" : "a";
    const tabIndex = isCurrentPath ? void 0 : 0;
    const ContentTag = typography === "title" ? Title : Text;
    const navigationProps = pickNavigationProps({ isCurrentPath, href, onClick });
    const { isDraggedOver, ...linkDragProps } = useLinkDrag({
      onDrop,
      onDragEnter,
      onDragOver,
      onDragLeave
    });
    const cls2 = classNames(
      "dig-Breadcrumb-link",
      { "dig-Breadcrumb-link--current": isCurrentPath },
      { "dig-Breadcrumb-link--dragged-over": isDraggedOver && !isCurrentPath },
      breadcrumbLink({ isCurrent: isCurrentPath, isDraggedOver: isDraggedOver && !isCurrentPath }),
      className
    );
    return /* @__PURE__ */ React5.createElement(
      WrapperTag,
      {
        id,
        className: cls2,
        tabIndex,
        ref,
        "aria-current": isCurrentPath ? "page" : void 0,
        ...navigationProps,
        ...linkDragProps,
        ...rest
      },
      /* @__PURE__ */ React5.createElement(
        ContentTag,
        {
          size,
          className: classNames("dig-Breadcrumb-link-content", breadcrumbLinkContent),
          color: isCurrentPath ? "standard" : "faint",
          tagName: "span",
          "data-testid": "digBreadcrumbLinkContent"
        },
        /* @__PURE__ */ React5.createElement(
          "span",
          {
            ref: linkContentRef,
            className: classNames("dig-Breadcrumb-link-inner", breadcrumbLinkInner)
          },
          withLeftIcon && /* @__PURE__ */ React5.createElement(
            UIIcon,
            {
              className: classNames("dig-Breadcrumb-link-icon", breadcrumbLinkIcon),
              src: withLeftIcon,
              size: iconSizerfier({ typography, size }),
              isOpticallyAligned: true
            }
          ),
          /* @__PURE__ */ React5.createElement("span", { className: classNames("dig-Breadcrumb-link-text", breadcrumbLinkText) }, children)
        )
      )
    );
  }
);
LinkContent.displayName = "LinkContent";

// ../src/breadcrumb/link/hidden_link.tsx
import { useResizeObserver, useIsomorphicLayoutEffect } from "@react-hookz/web";

// ../src/_global/resize_observer_polyfill.ts
import { ResizeObserver as ResizeObserverPolyfill } from "@juggle/resize-observer";
var polyfillResizeObserverGlobally = () => {
  if ("ResizeObserver" in globalThis === false) {
    globalThis.ResizeObserver = ResizeObserverPolyfill;
  }
};

// ../src/breadcrumb/link/hidden_link.tsx
polyfillResizeObserverGlobally();
var HiddenLink = React6.forwardRef(
  ({
    id,
    className,
    children,
    withLeftIcon,
    withMenuItemIcon,
    isCurrentPath = false,
    href,
    onClick,
    onDrop,
    onDragEnter,
    onDragOver,
    onDragLeave,
    _originalId = "",
    ...rest
  }, ref) => {
    const index = React6.useContext(LinkContext);
    const { updateSegment } = React6.useContext(BreadcrumbContext);
    const ariaLabel = rest["aria-label"];
    const linkContentRef = React6.useRef(null);
    useResizeObserver(linkContentRef, () => {
      updateSegment(
        index,
        {
          id,
          children,
          withLeftIcon,
          withMenuItemIcon,
          href,
          onClick,
          onDrop,
          onDragEnter,
          onDragOver,
          onDragLeave,
          "aria-label": ariaLabel,
          _originalId
        },
        calcItemWidth(linkContentRef)
      );
    });
    useIsomorphicLayoutEffect(() => {
      updateSegment(
        index,
        {
          id,
          children,
          withLeftIcon,
          withMenuItemIcon,
          href,
          onClick,
          onDrop,
          onDragEnter,
          onDragOver,
          onDragLeave,
          "aria-label": ariaLabel,
          _originalId
        },
        calcItemWidth(linkContentRef)
      );
    }, [
      id,
      children,
      withLeftIcon,
      withMenuItemIcon,
      href,
      onClick,
      onDrop,
      onDragEnter,
      onDragOver,
      onDragLeave,
      index,
      updateSegment,
      ariaLabel,
      _originalId
    ]);
    return /* @__PURE__ */ React6.createElement(
      LinkContent,
      {
        ref,
        id,
        className,
        withLeftIcon,
        withMenuItemIcon,
        isCurrentPath,
        href,
        onClick,
        linkContentRef,
        ...rest
      },
      children
    );
  }
);
HiddenLink.displayName = "HiddenLink";

// ../src/breadcrumb/link/crumb_link.tsx
import * as React7 from "react";
var CrumbLink = React7.forwardRef(
  ({
    id,
    className,
    children,
    withLeftIcon,
    withMenuItemIcon,
    isCurrentPath = false,
    href,
    onClick,
    _originalId = "",
    ...rest
  }, ref) => {
    const linkContentRef = React7.useRef(null);
    return /* @__PURE__ */ React7.createElement(
      LinkContent,
      {
        ref,
        id,
        className,
        withLeftIcon,
        withMenuItemIcon,
        isCurrentPath,
        href,
        onClick,
        linkContentRef,
        ...rest
      },
      children
    );
  }
);
CrumbLink.displayName = "CrumbLink";

// ../src/breadcrumb/link/index.tsx
var Link = React8.forwardRef((props, ref) => {
  const { id } = props;
  if (id && id.startsWith(LINK_HIDDEN_ID_PREFIX)) {
    return /* @__PURE__ */ React8.createElement(HiddenLink, { ref, id, ...props });
  }
  return /* @__PURE__ */ React8.createElement(CrumbLink, { ref, id, ...props });
});
Link.displayName = "Link";

// ../src/breadcrumb/breadcrumb.tsx
import { useResizeObserver as useResizeObserver2 } from "@dropbox/dig-components/hooks";

// ../src/breadcrumb/breadcrumb_renderer.tsx
import * as React12 from "react";

// ../src/breadcrumb/breadcrumb_divider.tsx
import * as React9 from "react";
import { Text as Text2, Title as Title2 } from "@dropbox/dig-components/typography";
import classNames2 from "classnames";
var BreadcrumbDivider = ({ className }) => {
  const { size, typography } = React9.useContext(BreadcrumbContext);
  const cls2 = classNames2("dig-Breadcrumb-divider", breadcrumbDivider, className);
  const TypographicComponent = typography === "title" ? Title2 : Text2;
  return /* @__PURE__ */ React9.createElement(
    TypographicComponent,
    {
      className: cls2,
      size: size === "standard" ? "medium" : size,
      tagName: "span",
      color: "disabled",
      "aria-hidden": "true"
    },
    "/"
  );
};
BreadcrumbDivider.displayName = "BreadcrumbDivider";

// ../src/breadcrumb/breadcrumb_overflow_menu_item.tsx
import * as React10 from "react";
import classNames3 from "classnames";
import { Menu } from "@dropbox/dig-components/menu";
var BreadcrumbOverflowMenuItem = ({
  className,
  onDragOver,
  onDragEnter,
  onDragLeave,
  onDrop,
  ...rest
}) => {
  const [isDraggedOver, setIsDraggedOver] = React10.useState(false);
  const cls2 = classNames3(
    { "dig-Breadcrumb-overlfow-item--dragged-over": isDraggedOver },
    breadcrumbOverflowMenuItem({ isDraggedOver }),
    className
  );
  const handleDragOver = React10.useCallback(
    (e) => {
      setIsDraggedOver(true);
      if (onDragOver) {
        onDragOver(e);
      }
    },
    [onDragOver]
  );
  const handleDragEnter = React10.useCallback(
    (e) => {
      setIsDraggedOver(true);
      if (onDragEnter) {
        onDragEnter(e);
      }
    },
    [onDragEnter]
  );
  const handleDragLeave = React10.useCallback(
    (e) => {
      setIsDraggedOver(false);
      if (onDragLeave) {
        onDragLeave(e);
      }
    },
    [onDragLeave]
  );
  const handleDrop = React10.useCallback(
    (e) => {
      setIsDraggedOver(false);
      if (onDrop) {
        onDrop(e);
      }
    },
    [onDrop]
  );
  return /* @__PURE__ */ React10.createElement(
    Menu.ActionItem,
    {
      tagName: "a",
      className: cls2,
      "aria-label": rest["aria-label"],
      onDrop: handleDrop,
      onDragOver: handleDragOver,
      onDragEnter: handleDragEnter,
      onDragLeave: handleDragLeave,
      role: "menuitem",
      ...rest
    }
  );
};
BreadcrumbOverflowMenuItem.displayName = "BreadcrumbOverflowMenuItem";

// ../src/breadcrumb/breadcrumb_overflow.tsx
import { IconButton } from "@dropbox/dig-components/buttons";
import { Menu as Menu2 } from "@dropbox/dig-components/menu";
import { UIIcon as UIIcon2 } from "@dropbox/dig-icons";
import { MoreHorizontalLine } from "@dropbox/dig-icons/assets";
import classNames4 from "classnames";
import * as React11 from "react";
var BreadcrumbOverflow = ({
  className,
  overflowItemsProps,
  overflowEventHandlers,
  ...rest
}) => {
  const { size, overflowTriggerProps, typography } = React11.useContext(BreadcrumbContext);
  const cls2 = classNames4("dig-Breadcrumb-overflow", className);
  const handleSelect = (value, evt) => {
    if (typeof value === "function") {
      value(evt);
    }
  };
  const triggerDragEvents = React11.useCallback(
    (openMenu, closeMenu) => {
      if (!overflowEventHandlers) {
        return {};
      }
      return {
        onDragOver: overflowEventHandlers.onDragOverTrigger ? overflowEventHandlers.onDragOverTrigger(openMenu) : void 0,
        onDragEnter: overflowEventHandlers.onDragEnterTrigger ? overflowEventHandlers.onDragEnterTrigger(openMenu) : void 0,
        onDragLeave: overflowEventHandlers.onDragLeaveTrigger ? overflowEventHandlers.onDragLeaveTrigger(closeMenu) : void 0
      };
    },
    [overflowEventHandlers]
  );
  const contentDragEvents = React11.useCallback(
    (openMenu, closeMenu) => {
      if (!overflowEventHandlers) {
        return {};
      }
      return {
        onDragOver: overflowEventHandlers.onDragOverContent ? overflowEventHandlers.onDragOverContent(openMenu) : void 0,
        onDragEnter: overflowEventHandlers.onDragEnterContent ? overflowEventHandlers.onDragEnterContent(openMenu) : void 0,
        onDragLeave: overflowEventHandlers.onDragLeaveContent ? overflowEventHandlers.onDragLeaveContent(closeMenu) : void 0
      };
    },
    [overflowEventHandlers]
  );
  return /* @__PURE__ */ React11.createElement(Menu2.Wrapper, { className: cls2, onSelection: handleSelect, shouldPropagateClickOutsideMouseEvents: true }, ({ getContentProps, getTriggerProps, openMenu, closeMenu }) => /* @__PURE__ */ React11.createElement(React11.Fragment, null, /* @__PURE__ */ React11.createElement(
    IconButton,
    {
      variant: "transparent",
      className: classNames4("dig-Breadcrumb-overflow-button", breadcrumbOverflowButton),
      "data-testid": "digBreadcrumbOverflowButton",
      size: typography === "title" ? "medium" : "small",
      ...getTriggerProps(overflowTriggerProps),
      ...triggerDragEvents(openMenu, closeMenu),
      ...rest
    },
    /* @__PURE__ */ React11.createElement(UIIcon2, { src: MoreHorizontalLine, size })
  ), /* @__PURE__ */ React11.createElement(Menu2.Content, { ...getContentProps(), ...contentDragEvents(openMenu, closeMenu) }, /* @__PURE__ */ React11.createElement(Menu2.Segment, null, overflowItemsProps.map((props, index) => {
    const {
      id,
      children,
      withMenuItemIcon,
      href,
      onClick,
      onDragOver,
      onDragEnter,
      onDragLeave,
      onDrop
    } = props;
    return props && /* @__PURE__ */ React11.createElement(
      BreadcrumbOverflowMenuItem,
      {
        id,
        "aria-label": props["aria-label"],
        value: href,
        href: typeof href === "string" ? href : void 0,
        onClick,
        onDragOver,
        onDragEnter,
        onDragLeave,
        onDrop,
        children,
        withLeftAccessory: withMenuItemIcon ? /* @__PURE__ */ React11.createElement(UIIcon2, { src: withMenuItemIcon }) : void 0,
        key: `overflow-item-${index}`
      }
    );
  })))));
};
BreadcrumbOverflow.displayName = "BreadcrumbOverflow";

// ../src/breadcrumb/breadcrumb_renderer.tsx
import cls from "classnames";
var BreadcrumbRenderer = ({
  segments,
  isRootOverflow,
  overflowEventHandlers
}) => {
  const { hasTrailingDivider } = React12.useContext(BreadcrumbContext);
  const res = [];
  segments.inline.forEach((segment, index) => {
    res.push(segment.item);
    if (index !== segments.inline.length - 1) {
      if (segments.overflow.length > 0 && !isRootOverflow && index === 0) {
        res.push(
          /* @__PURE__ */ React12.createElement(
            BreadcrumbDivider,
            {
              key: `divider-${index}`,
              className: "dig-Breadcrumb-divider--overflowLeft"
            }
          )
        );
      } else {
        res.push(/* @__PURE__ */ React12.createElement(BreadcrumbDivider, { key: `divider-${index}` }));
      }
    }
  });
  if (segments.overflow.length > 0) {
    let insertIdx = 2;
    if (segments.inline.length === 1 || isRootOverflow) {
      insertIdx = 0;
    }
    res.splice(
      insertIdx,
      0,
      /* @__PURE__ */ React12.createElement(BreadcrumbDivider, { key: `divider-${-1}`, className: "dig-Breadcrumb-divider--overflowRight" })
    );
    res.splice(
      insertIdx,
      0,
      /* @__PURE__ */ React12.createElement(
        BreadcrumbOverflow,
        {
          overflowItemsProps: segments.overflow.map((segment) => segment.linkProps),
          overflowEventHandlers,
          key: "overflow"
        }
      )
    );
  }
  if (hasTrailingDivider) {
    res.push(
      /* @__PURE__ */ React12.createElement(
        BreadcrumbDivider,
        {
          className: cls("dig-Breadcrumb-Divider--trailing", breadcrumbDividerTrailing),
          key: `trailing-divider`
        }
      )
    );
  }
  return /* @__PURE__ */ React12.createElement(React12.Fragment, null, res);
};
BreadcrumbRenderer.displayName = "BreadcrumbRenderer";

// ../src/breadcrumb/breadcrumb.tsx
import { Title as Title3, Text as Text3 } from "@dropbox/dig-components/typography";

// ../src/_global/virtual_element_ref.tsx
var createGetBoundingClientRect = (domRef) => ({
  getBoundingClientRect() {
    return domRef.current ? domRef.current.getBoundingClientRect() : new DOMRect();
  }
});

// ../src/breadcrumb/breadcrumb.tsx
import "focus-visible";
import { ThemeProvider, useTheme } from "@dropbox/dig-foundations";
import flattenChildren2 from "react-keyed-flatten-children";
var Breadcrumb = React13.forwardRef(
  ({
    className,
    children,
    size: _size = "medium",
    overflowEventHandlers,
    isRootOverflow = false,
    alwaysShowRoot = false,
    inverse = false,
    linksDisplayed,
    hasTrailingDivider = false,
    overflowTriggerProps = {},
    typography: _typography,
    ...rest
  }, ref) => {
    let size = getMigratedComponentSize(_size);
    let typography = _typography;
    const { nodeRef, observerEntry } = useResizeObserver2();
    const [breadcrumbSegments, setBreadcrumbSegments] = React13.useState(
      initSegments(children)
    );
    const [prevChildren, setPrevChildren] = React13.useState(children);
    const localRef = React13.useRef(null);
    const isLinksDisplayedValid = linksDisplayed && linksDisplayed > 0;
    if (!typography) {
      typography = size === "small" ? "text" : "title";
      size = size === "medium" ? "small" : size;
    }
    const cls2 = classNames5(
      "dig-Breadcrumb",
      { [`dig-Breadcrumb--small`]: size === "small" },
      { [`dig-Breadcrumb--size-${size}`]: size },
      { [`dig-Breadcrumb--typography-${typography}`]: typography },
      { "dig-Breadcrumb--linksDisplayed": isLinksDisplayedValid },
      breadcrumb({ size, typography, isLinksDisplayed: !!isLinksDisplayedValid }),
      className
    );
    const updateSegment = React13.useCallback(
      (index, linkProps, width) => {
        setBreadcrumbSegments(
          (breadcrumbSegments2) => breadcrumbSegments2.map((segment, i) => {
            if (i === index) {
              return {
                ...segment,
                width: Math.ceil(width),
                linkProps: {
                  // Save the original link props
                  ...linkProps,
                  id: linkProps._originalId,
                  _originalId: void 0
                }
              };
            }
            return segment;
          })
        );
      },
      []
    );
    const contextValue = {
      typography,
      size,
      updateSegment,
      hasTrailingDivider,
      overflowTriggerProps
    };
    const HiddenTag = typography === "title" ? Title3 : Text3;
    React13.useImperativeHandle(ref, () => {
      return createGetBoundingClientRect(localRef);
    });
    if (children !== prevChildren) {
      setPrevChildren(children);
      setBreadcrumbSegments(initSegments(children));
    }
    const breadcrumbContent = /* @__PURE__ */ React13.createElement(BreadcrumbContext.Provider, { value: contextValue }, /* @__PURE__ */ React13.createElement(
      HiddenTag,
      {
        size,
        className: classNames5("dig-Breadcrumb--widthCalcUtil", breadcrumbWidthCalcUtil),
        "aria-hidden": "true",
        tagName: "span"
      },
      flattenChildren2(children).map((child, index) => {
        if (React13.isValidElement(child)) {
          return /* @__PURE__ */ React13.createElement(LinkContext.Provider, { value: index, key: `hidden-link-${index}` }, React13.cloneElement(child, {
            id: `${LINK_HIDDEN_ID_PREFIX}-${index}`,
            // Only try to apply a prop if it's a Link component
            ...child.type === Link && { _originalId: child.props.id }
          }));
        }
      })
    ), /* @__PURE__ */ React13.createElement("nav", { className: cls2, ...rest, ref: isLinksDisplayedValid ? void 0 : nodeRef }, /* @__PURE__ */ React13.createElement(
      "div",
      {
        className: classNames5("dig-Breadcrumb-inner", breadcrumbInner),
        ref: localRef,
        "data-testid": "digBreadcrumbDisplayContainer"
      },
      /* @__PURE__ */ React13.createElement(
        BreadcrumbRenderer,
        {
          segments: isLinksDisplayedValid ? buildBreadcrumbWithLinksDisplayed({
            breadcrumbSegments,
            isRootOverflow,
            linksDisplayed
          }) : buildBreadcrumb({
            // In some cases, observerEntry may be undefined(e.g. container has `display: flex`),
            // we need to show minimum number of paths
            availableWidth: observerEntry ? observerEntry.contentRect.width : 0,
            breadcrumbSegments,
            size,
            isRootOverflow,
            alwaysShowRoot,
            hasTrailingDivider
          }),
          isRootOverflow,
          overflowEventHandlers
        }
      )
    )));
    const currentMode = useTheme().mode;
    if (inverse) {
      const newMode = currentMode === "bright" ? "dark" : "bright";
      return /* @__PURE__ */ React13.createElement(ThemeProvider, { mode: newMode }, ({ getThemeProps }) => {
        return /* @__PURE__ */ React13.createElement("div", { ...getThemeProps() }, breadcrumbContent);
      });
    }
    return breadcrumbContent;
  }
);
Breadcrumb.Link = Link;
Breadcrumb.displayName = "Breadcrumb";
export {
  Breadcrumb,
  Link,
  buildBreadcrumb,
  buildBreadcrumbWithLinksDisplayed,
  calcBreadcrumbWidth,
  calcItemWidth,
  initSegments,
  isAllUpdated
};
